export function withCountryCode(value, countryCode = '+91') {
  const text = value.trim();
  if (!text || text.includes('@')) return text;
  if (text.startsWith('+')) return text;
  if (text.startsWith('00')) return '+' + text.slice(2);
  if (!/^\+[1-9]\d{0,2}$/.test(countryCode.trim())) throw new Error('Enter a valid country calling code, e.g. +91');
  return countryCode.trim() + text;
}
